const namespace = "apckpiApp";

import AppConfig from "@/_config/application-config"
import childRoutes from "./routes"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {

  // "namespace" : {
  name: "apckpi",
  namespace,
  description: null,
  version: "1.0.0",
  /*version: "0.1.1",*/
  icon: "mdi-upload",
  accentColor: "#000080",
  mainNavEnabled: false,
  topBarEnabled: false,

  settings: {
    env_color_dev: { "r": 96, "g": 125, "b": 139, "a": 1 },
    env_color_stg: { "r": 38, "g": 166, "b": 154, "a": 1 },

    isAzureDeployed: true,

    appNavigation: [
      {
        icon: "mdi-book-open",
        text: "Overview",
        link: "Overview",
        roles: []
      },
      {
        icon: "mdi-factory",
        text: "Site Unit",
        link: "PlantUnit",
        roles: ["site engineer", "unit engineer", "global admin"]
      },
      {
        icon: "mdi-view-list",
        text: "Master Data",
        link: "MasterData",
        roles: ["global admin"]
      },
      {
        icon: "mdi-account-multiple-outline",
        text: "Users",
        link: "User",
        roles: ["global admin"]
      },
      {
        text: "Controller Info",
        link: "ApcController",
        icon: "mdi-table",
        roles: ["site viewer", "global admin", "site engineer", "unit engineer"],
      },
      {
        text: "Kpi Data Info",
        link: "KpiData",
        icon: "mdi-grid",
        roles: ["site viewer", "global admin", "site engineer", "unit engineer"],
      },
      {
        text: "Polymer LookUp",
        link: "PolymerLookUp",
        icon: "mdi-magnify",
        roles: ["global admin"]
      },
      {
        text: "Analyzer Tags",
        link: "AnalyzerTags",
        icon: "mdi-view-dashboard-outline",
        roles: ["global admin"]
      },
      {
        text: "Import Data",
        link: "DataValidation",
        icon: "mdi-cloud-download",
        roles: ["global admin"],
      },
      {
        text: "Logs",
        link: "Log",
        icon: "mdi-information",
        roles: ["global admin"],
      }

    ],

    // APCKPI API
    environment: "LAB",
    //grantType: "client_credentials",
    scope: "api://e01fd8c9-857f-4480-b8c4-2e9795224e97/Read.All",
    clientId: "e01fd8c9-857f-4480-b8c4-2e9795224e97",
    //apiUrl: "https://localhost:44339/api",
    apiUrl: "https://as-apckpi-api-stg.azurewebsites.net/api",
    //apiUrl: "https://api.nonprd.lyb.com/external/sippa-dev/api",
    //apiUrl: "https://as-incubator-api-dev.azurewebsites.net/api",
    authorizeUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    redirect_uri: window.location.origin,
    logoutUrl:
      `https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri==${window.location.origin}`,
    tokenUrl:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    sheetProtectionKey: "",

  },


  parentRoute: "/apckpi",
  defaultRoute: "apckpi",
  //accentColor: "#000080",
  childRoutes,
  component: () => import(/* webpackChunkName: "sippa" */ "@/apps/apckpi/Application.vue"),
  navigation: [
    // {
    //   title: "Employee Info",
    //   route: "EmployeeInfo",
    //   icon: "mdi-grid",
    // },
    // {
    //   title: "PlantUnit",
    //   route: "PlantUnit",
    //   icon: "mdi-factory",
    // },

  ],
  store: {
    //The store is made up of settings and attributes that should be accessible across components.
    //One common scenario would be user settings or profile preferences.  Some examples:
    //Date and Time Formats
    //Preferred configuration of a table view
    //Preferred theme color.
    pageTitle: {
      default: "apckpi Home",
      storageMode: localStorage,
    },
    userDetails: {
      default: null,
      storageMode: sessionStorage,
    },
    credentialCache: {
      default: {},
      storageMode: sessionStorage,
    },
    userRoles: {
      default: [],
      storageMode: sessionStorage,
    },
    navItems: {
      default: [],
      storageMode: sessionStorage,
    },
    themeColor: {
      default: "red",
      storageMode: localStorage,
    },
    isTrue: {
      default: true,
      storageMode: sessionStorage,
    },
  }

}

export default AppConfig.merge(appConfig);


